// extracted by mini-css-extract-plugin
export default {"input":"serachInput_input__4YGjB"};